<template>
  <div class="">
    <p>
      {{ params.data.clinic.title }}
    </p>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'CellRendererLink',
  data() {
    return {}
  },
  methods: {
  },
  computed: {
    url () {
      return '/patients/patient/view/'+this.params.data.patient.id

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  }
}
</script>
